var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useCallback } from 'react';
import { Input, Box } from "./..";
import { useToggle } from "../../hooks";
import styled from "../../styled";
var sliderHeight = {
    sm: 22,
    md: 25
};
var sliderWidth = {
    sm: sliderHeight.sm * 2,
    md: sliderHeight.md * 2
};
var knobPadding = {
    sm: sliderHeight.sm * 0.16,
    md: sliderHeight.md * 0.16
};
var knobDiameter = {
    sm: sliderHeight.sm - knobPadding.sm * 2,
    md: sliderHeight.md - knobPadding.md * 2
};
var getSliderThemeLss = function (_a) {
    var theme = _a.theme, scale = _a.scale, checked = _a.checked;
    var isCintTheme = (theme === null || theme === void 0 ? void 0 : theme.template) === 'CINT';
    var bgActiveColor = isCintTheme
        ? theme.colors.secondary400
        : theme.colors.secondary500;
    var bgNonActiveColor = isCintTheme
        ? theme.colors.white
        : theme.colors.gray500;
    var borderLss = isCintTheme && !checked ? '1px black solid' : 'none';
    var knobBgColor = isCintTheme && !checked ? theme.colors.primary500 : theme.colors.white;
    var knobPaddingTop = isCintTheme && !checked ? knobPadding[scale] - 1 : knobPadding[scale];
    return {
        bgActiveColor: bgActiveColor,
        bgNonActiveColor: bgNonActiveColor,
        knobBgColor: knobBgColor,
        borderLss: borderLss,
        knobPaddingTop: knobPaddingTop
    };
};
var Slider = styled.span.attrs({
    'aria-hidden': true
})(function (_a) {
    var theme = _a.theme, checked = _a.checked, disabled = _a.disabled, scale = _a.scale;
    var _b = getSliderThemeLss({ theme: theme, checked: checked, scale: scale }), bgActiveColor = _b.bgActiveColor, bgNonActiveColor = _b.bgNonActiveColor, knobBgColor = _b.knobBgColor, borderLss = _b.borderLss, knobPaddingTop = _b.knobPaddingTop;
    return "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  box-sizing: border-box;\n  border: " + borderLss + ";\n  background-color: " + (disabled ? theme.colors.gray200 : checked ? bgActiveColor : bgNonActiveColor) + ";\n  border-radius: " + sliderHeight[scale] * 2 + "px;\n  &::before {\n    position: absolute;\n    content: '';\n    height: " + knobDiameter[scale] + "px;\n    width: " + knobDiameter[scale] + "px;\n    left: " + knobPadding[scale] + "px;\n    top: " + knobPaddingTop + "px;\n    background-color: " + knobBgColor + ";\n    transition: " + theme.transitions.fast + ";\n    border-radius: 100%;\n    transform: " + (checked ? "translateX(" + sliderHeight[scale] + "px)" : '') + ";\n    box-shadow: " + theme.shadows.xs + ";\n  }\n";
});
var UncontrolledToggle = function (_a) {
    var value = _a.value, disabled = _a.disabled, onChange = _a.onChange, _b = _a.scale, scale = _b === void 0 ? 'md' : _b, lss = _a.lss, otherProps = __rest(_a, ["value", "disabled", "onChange", "scale", "lss"]);
    var _c = __read(useToggle(false), 2), isFocused = _c[0], toggle = _c[1];
    return (React.createElement(Box, { "aria-disabled": disabled ? 'true' : 'false', "aria-checked": value ? 'true' : 'false', role: "switch", onFocus: toggle, onBlur: toggle, lss: __assign({ position: 'relative', width: sliderWidth[scale], height: sliderHeight[scale], cursor: disabled ? 'not-allowed' : 'pointer', outline: function (_a) {
                var theme = _a.theme;
                return isFocused ? theme.colors.secondary500 + " solid 1px" : 'none';
            } }, lss) },
        React.createElement(Slider, { checked: value, disabled: disabled, scale: scale }),
        React.createElement(Input, __assign({}, otherProps, { disabled: disabled, checked: value, onChange: function (ev) {
                onChange && onChange(ev.target.checked);
            }, type: "checkbox", lss: {
                position: 'absolute',
                opacity: 0,
                width: '100%',
                height: '100%'
            } }))));
};
var ControlledToggle = function (_a) {
    var defaultValue = _a.defaultValue, onChange = _a.onChange, props = __rest(_a, ["defaultValue", "onChange"]);
    var _b = __read(useState(defaultValue), 2), value = _b[0], setValue = _b[1];
    var handleChange = useCallback(function () {
        setValue(function (prevValue) {
            onChange && onChange(!prevValue);
            return !prevValue;
        });
    }, [setValue, onChange]);
    return (React.createElement(UncontrolledToggle, __assign({}, props, { value: value, onChange: handleChange })));
};
export var Toggle = function (props) {
    if ('onChange' in props && 'value' in props) {
        return React.createElement(UncontrolledToggle, __assign({}, props));
    }
    return React.createElement(ControlledToggle, __assign({}, props));
};
//# sourceMappingURL=Toggle.js.map